import { useState, useEffect, useMemo } from "react";
import axiosInstance from "../../utils/axios";

const useDropdownPostFetch = (url, requestBody) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const memoizedRequestBody = useMemo(() => requestBody, [JSON.stringify(requestBody)]);

  useEffect(() => {
    const fetchDropdownData = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.post(url, memoizedRequestBody);

        let rawData = null;

        // Handle both formats
        if (response.data?.status?.toLowerCase?.() === "success" && response.data.message) {
          rawData = response.data.message;
        } else if (response.data?.Status?.toLowerCase?.() === "success" && response.data.Data) {
          rawData = response.data.Data;
        }

        if (rawData && typeof rawData === "object") {
          const parsedOptions = Object.entries(rawData).map(([key, label]) => ({
            value: isNaN(key) ? key : parseInt(key),
            label
          }));
          setOptions([{ value: "", label: "Select" }, ...parsedOptions]);
        } else {
          throw new Error("Unexpected response format");
        }

      } catch (error) {
        console.error(`POST dropdown error for ${url}:`, error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDropdownData();
  }, [url, memoizedRequestBody]);

  return { options, loading, error };
};

export default useDropdownPostFetch;
